/**
 * External dependencies
 */
import Backbone from 'backbone';
import _ from 'underscore';

/**
 * [EventHub EventHub object]
 * Provides a communication channel for widgets and isolated components
 * @type {[Backbone.Events]}
 * @constructor
 */
var EventHub = _.extend({}, Backbone.Events);

/**
 * EventHub event glossary
 * @namespace
 */
EventHub.events = {
    /**
     * Events related to URL alteration
     * Fired by @see {@link FilterView#applyFilter}
     */
    'navigate': {
      id: 'navigate'
    },

    /**
     * [Events related to filter submission]
     */
    'filter': {
        /**
         * Fired by @see {@link FilterView#onChangingFilter}
         * Listened by @see {@link FilterView#render}
         */
        'setState': {id: 'filter:setState'}
    },

    /**
     * [Events related to ranking submission]
     */
    'ranking': {
        /**
         * Fired by @see {@link appRouter#rankingViewer}
         * Listened by @see {@link RankingView#render}
         */
        'setItems': {id: 'ranking:setItems'},
    },
};

// EventHub exported elements (EventHub class)
export default EventHub;
